import React, { useEffect, useState } from "react";
import { AddChannelButtonIcon, BlackRightArrowIcon, BlueLeftArrowIcon, ExpandLessIcon, ExpandMoreIcon } from '../../icon';
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import ButtonComponent from "../shared/button/button.component";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";
import { Popover } from "@mui/material";


interface IProps {
    Options: { Label: string, ChannelType: number, Icon: any, ActiveIcon?: any, hasSubOptions: boolean, SubOptions: any, Active: boolean, SubOptionsOpen: boolean }[]
    handleSidebarWidth: (width: number) => void;
    handleOptions: (options) => void;
    HideAddChannelButton?: boolean;
}


const SelectChannelSideBarComponent: React.FC<IProps> = (props: IProps) => {
    const navigate = useNavigate();
    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

    const [sidebarState, setSidebarState] = useState<string>("expand")
    const [channelOptions, setChannelOptions] = useState<{ Label: string, ChannelType: number, Icon: any, ActiveIcon?: any, hasSubOptions: boolean, SubOptions: any, Active: boolean, SubOptionsOpen: boolean }[]>(props.Options ? props.Options : null);

    const [anchorEl, SetAnchorEl] = useState(null);


    useEffect(() => {
        setChannelOptions(props.Options)
    }, [props.Options])


    const handleChannelSideBar = () => {
        if (sidebarState === "expand") {
            setChannelOptions(channelOptions.map((x) => x && { ...x, SubOptionsOpen: false }))
            setSidebarState("collapse")
            props.handleSidebarWidth(10)
        }
        else {
            setChannelOptions(channelOptions.map((x) => x.Active ? { ...x, SubOptionsOpen: true } : x))
            setSidebarState("expand")
            props.handleSidebarWidth(24)
        }
    }

    const handleActive = (label) => {
        let selectedOption = channelOptions.find(x => x.Label === label)
        let options = channelOptions
        if (selectedOption.hasSubOptions) {
            setSidebarState("expand")
            props.handleSidebarWidth(24)
        }
        if (selectedOption.Active) {
            options = channelOptions.map(x => x === selectedOption ? { ...x, SubOptionsOpen: !selectedOption.SubOptionsOpen } : x)
        }
        else {
            let selectedChannelFirstSubOptions = channelOptions.find(x => x.Label === label)?.SubOptions?.find(x => x.Active === false)
            options = channelOptions.map(x => x.Label === label ? { ...x, Active: true, SubOptionsOpen: true, SubOptions: x.SubOptions?.map(suboptions => selectedChannelFirstSubOptions?.Label === suboptions.Label ? { ...suboptions, Active: true } : suboptions) } : { ...x, Active: false, SubOptionsOpen: false, SubOptions: x.SubOptions?.map(x => { return { ...x, Active: false } }) })
        }
        setChannelOptions(options)
        props.handleOptions(options)
        SetAnchorEl(null)
    }

    const handleSubOptionActive = (ChannelLabel, subOptionLabel) => {
        let selectedChannel = channelOptions.find(x => x.Label === ChannelLabel)
        let selectedSubOption = selectedChannel.SubOptions.find(x => x.Label === subOptionLabel)
        let options = channelOptions
        if (!selectedSubOption.Active) {
            options = channelOptions.map(x => x === selectedChannel ? { ...x, SubOptions: x.SubOptions.map(x => x === selectedSubOption ? { ...x, Active: true } : { ...x, Active: false }) } : x)
        }
        setChannelOptions(options)
        props.handleOptions(options)
    }

    const handleClickOptions = (event: React.MouseEvent) => {
        SetAnchorEl(event.currentTarget);
    };

    const handleCloseOptions = () => {
        SetAnchorEl(null);
    };

    return (
        <div className="w-p-100 h-p-100 d-flex flex-direction bg-color-secondary br-2">

            {IsMobileDevice && channelOptions.filter(x => x.Active).map(
                x => {
                    const Icon = x.ActiveIcon ? x.ActiveIcon : x.Icon;
                    return <div className={`w-5 h-5 d-flex align-center w-space h4-regular justify-center select-channel-active-background select-channel-active-border br-2 c-pointer o-hidden mx-auto`} onClick={handleClickOptions} >
                        <Icon className={` min-w-3 min-h-3 max-w-3 max-h-3`} />
                    </div>
                })
            }

            <Popover
                classes={{ paper: "w-24 py-2" }}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleCloseOptions}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                {channelOptions.filter(x => (ActiveChannelsTypes.includes(x.ChannelType) || x.ChannelType === 100)).map(
                    x => {
                        const Icon = x.ActiveIcon ? x.ActiveIcon : x.Icon;
                        return (
                            <>
                                <div className={`h-5 d-flex align-center mb-1`} onClick={() => handleActive(x.Label)} >
                                    {sidebarState === "collapse" && <div className={`w-p-10 d-flex align-center justify-flex-end`}>
                                        {x.Active && <div style={{ borderLeft: "0.25rem solid #1450FF", borderRadius: "0px 6px 6px 0px", }} className="h-5">
                                        </div>}
                                    </div>
                                    }
                                    <div className={`${sidebarState === "expand" ? "w-p-80" : "w-p-60"} h-p-100 d-flex align-center w-space h4-regular ${sidebarState === "expand" ? "mx-auto pl-1" : "justify-center"} ${x.Active && "select-channel-active-background select-channel-active-border br-2"} c-pointer o-hidden mx-auto`}>
                                        <Icon className={`${sidebarState === "expand" ? "mr-1" : ""} min-w-3 min-h-3 max-w-3 max-h-3`} />
                                        {sidebarState === "expand" ? x.Label.length > 21 ? x.Label.slice(0, 18) + "..." : x.Label : ""}
                                        {
                                            sidebarState === "expand" &&
                                            <div className={`ml-2`}>{x.hasSubOptions && (x.SubOptionsOpen ? <ExpandLessIcon className="c-pointer" /> : <ExpandMoreIcon className="c-pointer" />)}
                                            </div>
                                        }
                                    </div>

                                    {sidebarState === "collapse" &&
                                        <div className={`w-p-10 d-flex align-center justify-flex-end`}>

                                        </div>
                                    }
                                </div>
                                {x.Active && x.hasSubOptions && x.SubOptionsOpen &&
                                    <div className="max-h-25 w-p-100 o-y-auto">
                                        {x.SubOptions?.map((y, index) => {
                                            return (
                                                <div className={`${y.Active && "color-nav-bar-font-color-highlight"}  min-h-4 d-flex align-center h5-medium ${!y.Active && ""} o-hidden c-pointer ml-3 br-2 w-space`} onClick={() => handleSubOptionActive(x.Label, y.Label)}>
                                                    <Icon className={"min-w-2 max-w-2 px-1"} /> {(y.Label.length > 21) ? y.Label.slice(0, 18) + "..." : y.Label}
                                                </div>
                                            )
                                        })}
                                    </div>
                                }
                            </>
                        )
                    })
                }
            </Popover>

            {
                !IsMobileDevice && <div className={`h-p-10 d-flex align-center h5-regular ${sidebarState === "collapse" ? "w-p-70 mx-auto" : "w-p-100 mx-auto"}`}>
                    <div className={` ${sidebarState === "expand" ? "mx-2" : "w-p-100"} d-flex justify-center align-center`}>
                        {sidebarState === "expand" ? <BlueLeftArrowIcon className="min-w-2 c-pointer" height={12} onClick={() => { handleChannelSideBar() }} /> :
                            <div className={`w-3 h-3 br-p-50 d-flex justify-center align-center c-pointer channel-side-bar-icon-box-shadow`} onClick={() => { handleChannelSideBar() }}>
                                <BlackRightArrowIcon />
                            </div>
                        }
                    </div>
                    {sidebarState === "expand" && <div className="h4-medium color-primary-accent w-space o-hidden w-p-80">All Channels</div>}
                </div>
            }

            {!IsMobileDevice && channelOptions.filter(x => (ActiveChannelsTypes.includes(x.ChannelType) || x.ChannelType === 100)).map(
                x => {
                    const Icon = x.ActiveIcon ? x.ActiveIcon : x.Icon;
                    return (
                        <>
                            <div className={`h-5 d-flex align-center mb-1`} onClick={() => handleActive(x.Label)} >
                                {sidebarState === "collapse" && <div className={`w-p-10 d-flex align-center justify-flex-end`}>
                                    {x.Active && <div style={{ borderLeft: "0.25rem solid #1450FF", borderRadius: "0px 6px 6px 0px", }} className="h-5">
                                    </div>}
                                </div>
                                }
                                <div className={`${sidebarState === "expand" ? "w-p-80" : "w-p-60"} h-p-100 d-flex align-center w-space h4-regular ${sidebarState === "expand" ? "mx-auto pl-1" : "justify-center"} ${x.Active && "select-channel-active-background select-channel-active-border br-2"} c-pointer o-hidden mx-auto`}>
                                    <Icon className={`${sidebarState === "expand" ? "mr-1" : ""} min-w-3 min-h-3 max-w-3 max-h-3`} />
                                    {sidebarState === "expand" ? x.Label.length > 21 ? x.Label.slice(0, 18) + "..." : x.Label : ""}
                                    {
                                        sidebarState === "expand" &&
                                        <div className={`ml-2`}>{x.hasSubOptions && (x.SubOptionsOpen ? <ExpandLessIcon className="c-pointer" /> : <ExpandMoreIcon className="c-pointer" />)}
                                        </div>
                                    }
                                </div>

                                {sidebarState === "collapse" &&
                                    <div className={`w-p-10 d-flex align-center justify-flex-end`}>

                                    </div>
                                }
                            </div>
                            {x.Active && x.hasSubOptions && x.SubOptionsOpen &&
                                <div className="max-h-25 w-p-100 o-y-auto">
                                    {x.SubOptions?.map((y, index) => {
                                        return (
                                            <div className={`${y.Active && "color-nav-bar-font-color-highlight"}  min-h-4 d-flex align-center h5-medium ${!y.Active && ""} o-hidden c-pointer ml-3 br-2 w-space`} onClick={() => handleSubOptionActive(x.Label, y.Label)}>
                                                <Icon className={"min-w-2 max-w-2 px-1"} /> {(y.Label.length > 21) ? y.Label.slice(0, 18) + "..." : y.Label}
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                        </>
                    )
                }
            )}

            {!props.HideAddChannelButton && !IsMobileDevice && <ButtonComponent ButtonLabel={`${sidebarState === "collapse" ? "" : "Add channel"}`} Icon={AddChannelButtonIcon} Variant="secondary-btn-small" ClassName={`h5-medium mt-auto mb-2 mx-auto ${sidebarState === "collapse" ? "w-p-60 d-flex justify-center align-center h-6" : "w-p-80"}`} OnClick={() => { navigate(AppRoutes.ADD_CHANNELS) }} />}

        </div >
    )
}

export default SelectChannelSideBarComponent;